import {formattedTime} from '../helpers';
import {DefaultSettingsResponseProps, TimeSettingsProps} from '../types';
import SettingRow from './SettingRow';
import {FC} from 'react';

type DefaultSettingsBlockProps = {
  defaultSettings: DefaultSettingsResponseProps[];
  defaultSettingsKeys: TimeSettingsProps[];
  className?: string;
}

const DefaultSettingsBlock: FC<DefaultSettingsBlockProps> = (
    {defaultSettings, defaultSettingsKeys, className = ''}
) => (
  <div className={className}>
    {!!defaultSettings?.length &&
    defaultSettingsKeys.map((task) => {
      const setting = defaultSettings
          .find((item) => item.key === task.key);

      const {minutes, seconds, hours} =
      formattedTime(Number(setting?.value), task.withHours);

      return (
        <SettingRow
          key={setting?.key}
          hours={hours}
          minutes={minutes}
          seconds={seconds}
          label={task.label}
        />
      );
    })
    }
  </div>
);

export default DefaultSettingsBlock;
